function convertDimension(value: number | null, factor: number): number | null {
	if (value !== null && value > 0) {
		return value * factor;
	}
	return 0;
}

export const imperialMetricConverter = (
	type: string,
	values: {
		weight: number | null;
		length: number | null;
		width: number | null;
		height: number | null;
	},
	linearTotalFeet?: number,
) => {
	if (type === "LB/IN") {
		return {
			weight: (values.weight ?? 0) * 2.204_62,
			length: convertDimension(values.length, 0.393_701),
			width: convertDimension(values.width, 0.393_701),
			height: convertDimension(values.height, 0.393_701),
			totalLinearFeet: convertDimension(linearTotalFeet ?? 0, 0.393_701),
		};
	}
	if (type === "KG/CM") {
		return {
			weight: (values.weight ?? 0) * 0.453_592,
			length: convertDimension(values.length, 2.54),
			width: convertDimension(values.width, 2.54),
			height: convertDimension(values.height, 2.54),
			totalLinearFeet: convertDimension(linearTotalFeet ?? 0, 2.54),
		};
	}
	return {
		weight: values.weight,
		length: values.length,
		width: values.width,
		height: values.height,
	};
};
